import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';


const Sidebar = () => {
  let menuItems = [
    { title: 'Vinhos', url: '/wines' },
    { title: 'Calendário', url: '/calendar' },
    { title: 'Atividades', url: '/activities' },
    { title: 'Garrafas', url: '/bottles' },
    { title: 'Capacidades', url: '/bottle-capacities' },
    { title: 'Anos de Colheita', url: '/grape-harvest-years' },
    { title: 'Localidades', url: '/countries' },
    { title: 'Produtores', url: '/producers' },
    { title: 'Regiões', url: '/regions' },
    { title: 'Garrafeira', url: '/wine-cellars' },
    { title: 'Seções de Garrafeira', url: '/wine-cellar-sections' },
    { title: 'Quintas', url: '/wine-farms' },
    // { title: 'Wine Grapes', url: '/wine-grapes' },
    { title: 'Enólogos', url: '/wine-makers' },
    // { title: 'Fotos de Vinho', url: '/wine-photos' },
    // { title: 'Wine States', url: '/wine-states' },
    // { title: 'Notas de Prova', url: '/wine-tasting-notes' },
    { title: 'Tipos', url: '/wine-types' },
    { title: 'Castas', url: '/wine-varieties' },

  ];
  const [menu, setMenu] = React.useState(false)
  function handleClick(e) {
    e.preventDefault()
    setMenu(!menu)
    console.log('cliquei', menu)
  }

  return (
    <>
      <nav className="side-nav">
        <a href="/" className="intro-x flex items-center pl-5 pt-4">
          {/* <img alt="" className="w-6" src="dist/images/logo.svg" /> */}
          <span className="hidden xl:block text-white text-lg ml-3">
            {process.env.REACT_APP_ADMIN_TITLE}
            <span className="font-medium"> Admin</span>
          </span>
        </a>
        <div className="side-nav__devider my-4"></div>
        <ul>
          {menuItems.map((item, i) => {
            return (
              <li className="" key={i}>
                <a href={item.url} className="side-menu">
                  <div className="side-menu__title">
                    {item.title}
                    <div className="side-menu__sub-icon">
                      <FontAwesomeIcon icon={faChevronRight} />
                    </div>
                  </div>
                </a>
              </li>
            );
          })}
        </ul>
      </nav>
      <div className="absolute z-50 right-2 p-4 menu-hamburguer rounded  bg-dark-2 xl:hidden">
        <a onClick={(e) => handleClick(e)} className="relative right-0 "> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bar-chart-2 w-8 h-8 text-white transform -rotate-90"><line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line></svg> </a>
        {menu &&
          <ul className="absolute right-0 bg-dark-2 px-8 py-4 z-50 whitespace-nowrap">
            {menuItems.map((item, i) => {
              return (
                <li className="list-none" key={i}>
                  <a href={item.url} className="block side-menu p-1">
                    <div className="side-menu__title">
                      {item.title}
                    </div>
                  </a>
                </li>
              );
            }
            )}
          </ul>

        }
      </div>


    </>
  );
}

export default Sidebar
